import SelectModePrivate from "./SelectModePrivate";

export default SelectModePrivate;
